import Alert from "react-bootstrap/Alert"
import {default as cx} from "classnames"

function ErrorPage({fullpage}) {
    return (
        <div className={cx("d-flex flex-center", {"message-fullpage": fullpage})}>
            <div className="message-box mt-5">
                <Alert className="d-flex align-items-center" variant="danger">
                    <i className="fas fa-exclamation-triangle me-2 text-danger"></i>
                    <p>
                        <strong>There was a problem completing your request.</strong>
                        <br />
                        If this problem persists please contact an administrator.
                    </p>
                </Alert>
            </div>
        </div>
    )
}

export function Error404Page({fullpage}) {
    return (
        <div className={cx("d-flex flex-center", {"message-fullpage": fullpage})}>
            <div className="message-box mt-5">
                <Alert className="d-flex align-items-center" variant="warning">
                    <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                    <p className="mb-0">
                        <strong>The page you were looking for could not be found.</strong>
                        <br></br>
                        If this problem persists please contact an administrator.
                    </p>
                </Alert>
            </div>
        </div>
    )
}

export default ErrorPage
